const HangarIconStyle = `
    position: relative;
    max-width: 24px;

    &:hover {
        .hangar-icon-tooltip {
            display: block;
        }
    }

    .hangar-icon-tooltip {
        display: none;
        position: absolute;
        top: calc(100% + 5px);
        right: -10px;
        padding: 8px 16px;
        width: max-content;
        max-width: 257px;
        font-size: 12px;
        font-weight: 600;
        background: #fff;
        border-radius: 4px;
        box-shadow: 0 8px 20px 0 rgba(34, 50, 84, 0.2);
        z-index: 1;

        &:before {
            content: '';
            position: absolute;
            bottom: 100%;
            right: 13px;
            border-left: 8px solid transparent;
            border-right: 8px solid transparent;
            border-bottom: 8px solid white;
        }
    }
` 

export default HangarIconStyle;